import React from "react";

import { component as PursFromTs } from "output/Components.PursFromTs";

export const PursFromTsExample: React.FC<Record<string, never>> = () => {
  return <PursFromTs initValue={42} />;
};
